<template>
    <div>
	<base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5 pb-6">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12 col-xl-10 m-auto">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                            <h3 class="mb-0">แก้ไขข้อมูลบัตรประชาชน</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <FormIdentity
                            :submit.sync="submit"
                            :data="data" 
                            :images="images"
                            :listNameTitle="ListNameTitle"
                            @showModalImages="showModalImages($event , $event)"
                            ref="identity"
                        />
                        <FormVerify :verify="verify"/>
                        <div class="row justify-content-end">
                            <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                <button
                                type="button"
                                class="btn btn-success btn-block btn-icon py-3"
                                @click="showComfirmModal('ยืนยันการเปลี่ยนแปลงข้อมูลบัตรประชาชน' , 'identity')"
                                v-if="auth0RoleUsage('memberedit')"
                                >ยืนยัน</button>
                            </div>
                        </div>
                    </template>
                </card>
            </div>
        </div>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12 col-xl-10 m-auto">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                            <h3 class="mb-0">แก้ไขข้อมูลบัญชีธนาคาร</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <FormAccount
                            :submit.sync="submitAccount"
                            :account="account"
                            :images="imagesAccount"
                            @showModalImages="showModalImages($event , $event)"
                            ref="account"
                        />
                        <div class="row justify-content-end">
                            <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                <button
                                type="button"
                                class="btn btn-success btn-block btn-icon py-3"
                                @click="showComfirmModal('ยืนยันการเปลี่ยนแปลงข้อมูลบัญชีธนาคาร' , 'account')"
                                v-if="auth0RoleUsage('memberedit')"
                                >ยืนยัน</button>
                            </div>
                        </div>
                    </template>
                </card>
            </div>
        </div>
    </div>
    <ModalImages :data="dataModalImages" ></ModalImages>
  </div>
</template>

<script>
import validatePop from "../plugins/validatePop.js"
import ModalImages from '@/components/Modals/Modal-images'
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import formatBank from "@/plugins/formatBank.js";
import FormIdentity from '@/components/custom/member/FormIdentity'
import FormAccount from '@/components/custom/member/FormAccount'
import { checkPersonID } from "@/plugins/posHelper.js";
import FormVerify from "../components/custom/member/FormVerify.vue";
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    name:"memberedit",
    components:{
    ModalImages,
    AutocompletesAddress,
    FormIdentity,
    FormAccount,
    FormVerify
},
    data(){
        return {
            busy:false,
            submit: false,
            submitAccount:false,
            bank: formatBank,
            verify:{
                status: null,
                remark: '',
            },
            data:{
                name_title: "",
                tax_id: "",
                laser_code: "",
                date_birthday: "",
                date_expiry: "",
                name: "",
                address: "",
                state: "",
                district: "",
                province: "",
                postcode: "",
                member_type:"",
                tel: "",
                file: "",
                showNameTitle: "nameTitle",
                errorTax: false,
            },
            account: [{}],
            dataModalImages:{
                show:false,
                img:false,
                name:"img"
            },
            images:[
                {
                    name:'image_tax_front',
                    lable:'รูปภาพบัตรประชาชนด้านหน้า',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_tax_back',
                    lable:'รูปภาพบัตรประชาชนด้านหลัง',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_tax_double',
                    lable:'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน', 
                    file:null,
                    preview:"", 
                }
            ],
            imagesAccount:[
                {
                    name:'image_account',
                    lable:'รูปภาพสมุดบัญชี',
                    file:null,
                    preview:"",
                }
            ],
            auth0RoleUsage: auth0RoleUsage
        }
    },
    mounted(){
        this.getMember()
    },
    methods:{
        showModalImages( img , name ){
           this.dataModalImages.show = true
           this.dataModalImages.img = img
           this.dataModalImages.name = name
        },
        getMember(){
            this.busy = true
            this.$http
                .get(this.$API_URL + `/shippop/member/${this.$route.params.Id}`,
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    let data = res.data.data
                    this.data.name_title = data.name_title
                    this.data.tax_id = data.tax_id
                    this.data.laser_code = data.laser_code
                    this.data.date_birthday = data.date_birthday
                    this.data.date_expiry = data.date_expiry
                    this.data.name = data.name
                    this.data.address = data.address
                    this.data.state = data.state
                    this.data.district = data.district
                    this.data.province = data.province
                    this.data.postcode = data.postcode
                    this.data.member_type = data.type
                    this.data.tel = data.tel
                    this.account = [{
                        'account_id': data.account[0].account_id,
                        'account_name': data.account[0].account_name,
                        'account_branch': data.account[0].account_branch,
                        'account_bank': data.account[0].account_bank,
                        'branch_code': data.account[0].branch_code
                    }]
                   
                    let image = Object.values(data.images)
                    if(this.data.member_type == 'company'){
                        this.images = [
                            {
                                name:'image_company_certificate',
                                lable:'รูปภาพหนังสือรับรองบริษัท (หน้าแรก)',
                                file:null,
                                preview:"",
                            },
                            {
                                name:'image_certified_of_vat',
                                lable:'รูปภาพภพ.20 (หน้าแรก ถ้ามี)',
                                file:null,
                                preview:"",
                            },
                        ]
                    }else if(this.data.member_type == 'passport'){
                        this.images = [
                            {
                                name:'image_passport_front',
                                lable:'รูปภาพพาสปอร์ตด้านหน้า',
                                file:null,
                                preview:"",
                            },
                            {
                                name:'image_passport_double',
                                lable:'รูปถ่ายคู่กับพาสปอร์ต',
                                file:null,
                                preview:"",
                            },
                            
                        ]
                        this.data.showNameTitle = 'nameTitleEng'
                        this.data.name_title = this.ListNameTitle.filter(( item ) =>{
                            return item.nameTitle === this.data.name_title
                        })[0].nameTitleEng
                    }

                    this.images.forEach((item , index) => {
                        this.images[index].preview = image[index]
                        this.images[index].file = this.images[index].name
                    }); 

                    let imageAccount = Object.values(data.imageAccount)
                    if(this.data.member_type == 'company'){
                        this.imagesAccount = [
                            {
                                name:'image_business_account',
                                lable:'รูปภาพสมุดบัญชีบริษัท (เป็นชื่อบริษัทเท่านั้น)', 
                                file:null,
                                preview:"", 
                            }
                        ]
                    }
                    this.imagesAccount.forEach((item , index) => {
                        this.imagesAccount[index].preview = imageAccount[index]
                        this.imagesAccount[index].file = this.imagesAccount[index].name
                    }); 

                    this.verify.status = data.status
                    this.verify.remark = data.remark
                    this.handleLoader();
                });
        },
        changeIdentity(){
            this.submit = true
            this.$refs.identity.$v.$touch();
            if (this.$refs.identity.$v.$invalid) {
                return false
            }
            if ( this.data.tax_id.length == 13 && /^([0-9]{1,})$/.test(this.data.tax_id) ){
                let checkCardId = checkPersonID(this.data.tax_id);
                this.data.errorTax = false;
                if( !checkCardId ){
                    this.data.errorTax = true;
                    return false;
                }
            }
            if(typeof this.data.name_title == 'string'){
                if(this.data.member_type != 'passport'){
                    this.data.name_title = this.ListNameTitle.filter(( item ) =>{
                        return item.nameTitle === this.data.name_title
                    })[0];
                }else{
                    this.data.name_title = this.ListNameTitle.filter(( item ) =>{
                        return item.nameTitleEng === this.data.name_title
                    })[0];
                }
            }
            this.busy = true
            this.$http
            .put(
                this.$API_URL + `/shippop/change/identity/${this.$route.params.Id}`,
                {
                    tax_id: this.data.tax_id,
                    tel: this.data.tel,
                    name_title: this.data.name_title,
                    name: this.data.name,
                    address: this.data.address,
                    state: this.data.state,
                    district: this.data.district,
                    province: this.data.province,
                    postcode: this.data.postcode,
                    images: this.images,
                    laser_code: this.data.laser_code,
                    date_birthday: this.data.date_birthday,
                    date_expiry: this.data.date_expiry,
                    status: this.verify.status,
                    remark: this.verify.remark
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
            )
            .then(res => {
                let checkError = validatePop( res )
                if( !checkError.status ){
                    this.handleLoader();
                    this.sendErrorToLine( res )
                    this.showErrorModal( checkError.msg )
                    return false
                }
                this.handleLoader()
                this.showSuccessComfirmModal("แก้ไขข้อมูลบัตรประชาชนเรียบร้อยแล้ว")
            })
            .catch(error => { 
            });
        },
        changeAccount(){
            this.submitAccount = true
            this.$refs.account.$v.$touch();
            if (this.$refs.account.$v.$invalid) {
                return false
            }
            if(this.account[0].branch_code.length == 3){
                this.account[0].branch_code = "0"+this.account[0].branch_code
            }
            this.busy = true
            this.$http
            .put(
                this.$API_URL + `/shippop/change/account/${this.$route.params.Id}`,
                {
                    account: this.account,
                    images: this.imagesAccount,
                    status: this.verify.status,
                    remark: this.verify.remark
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
            )
            .then(res => {
                let checkError = validatePop( res )
                if( !checkError.status ){
                    this.handleLoader();
                    this.sendErrorToLine( res )
                    this.showErrorModal( checkError.msg )
                    return false
                }
                this.handleLoader()
                this.showSuccessComfirmModal("แก้ไขข้อมูลบัญชีธนาคารเรียบร้อยแล้ว")
            })
            .catch(error => { 
            });
        },
        sendErrorToLine(res){
            this.$http.post( this.$API_URL + "/lineNotify/error", {
                error: res
            },
            {
                headers: {
                "Content-Type": "application/json",
                Token: localStorage.getItem("access_token")
                }
            })
        },
        reset(){
            location.reload();
        },
        handleLoader(){
            this.busy = !this.busy
        },
        showComfirmModal(msgBody , type) {
            this.$bvModal
            .msgBoxConfirm(msgBody, {
                title: "กรุณายืนยัน",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "ยืนยัน",
                cancelTitle: "ยกเลิก",
                contentClass: "modal-confirm",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    if(type === 'identity'){
                        this.changeIdentity();
                    }else{
                        this.changeAccount();
                    }
                }
            });
        },
        showSuccessComfirmModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "SUCCESS",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ตกลง",
            contentClass: "modal-success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            })
            .then(value => {
                if (value) {
                    this.reset();
                }
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: OkmsgTitle,
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
    },
    computed:{
        ListNameTitle(){
            if( this.data.member_type == 'person' ){
                return  [
                    { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
                    { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
                    { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'},
                    { code: 7 , nameTitle: 'ว่าที่ ร.ต. หญิง' , nameTitleEng: 'MISS'},
                    { code: 8 , nameTitle: 'พลฯหญิง' , nameTitleEng: 'MISS'},
                    { code: 9 , nameTitle: 'ว่าที่ ร.ต.' , nameTitleEng: 'MR'},
                ]
            }else if( this.data.member_type == 'company'){
                return  [
                    { code: 4 , nameTitle: 'บจก.' , nameTitleEng: 'MR'},
                    { code: 5 , nameTitle: 'บริษัท' , nameTitleEng: 'MR'},
                    { code: 6 , nameTitle: 'ห้างหุ้นส่วนจำกัด' , nameTitleEng: 'MR'},
                ]
            }else{
                return  [
                    { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
                    { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
                    { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'},
                ]
            }
        }
    }
}
</script>

<style scoped>
.image-hover{
border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}
.image-hover:hover {opacity: 0.7;}

</style>